import React from 'react'
import { Grid, GridItem, Text } from '@chakra-ui/react'
import PartnerInformation from './PartnerInformation'
import AccommodationInformation from './AccommodationInformation'
import FamilyInformation from './FamilyInformation'
import RenderFlowDocuments from '../RenderFlowDocuments'
import AdditionalInformation from './AdditionalInformation'
import { SectionAccordion } from '../../UI'

const NewbornBenefit = ({ program }) => {
  const renderViewTitle = (title) => (
    <Text
      fontWeight={700}
      bg={'green.100'}
      color={'white'}
      fontSize={20}
      borderRadius={8}
      px={5}
      py={1}
      my={4}
    >
      {title}
    </Text>
  )

  return (
    <Grid templateColumns={'repeat(1, minmax(0, 1fr))'} gap={2}>
      <GridItem>
        <PartnerInformation program={program} />
      </GridItem>
      <GridItem>
        {renderViewTitle('Información del hospedaje')}
        <AccommodationInformation program={program} />
      </GridItem>
      <GridItem>
        {renderViewTitle('Información de huésped y huéspedes adicionales')}
        <FamilyInformation program={program} />
      </GridItem>
      <GridItem>
        {renderViewTitle('Información adicional')}
        <AdditionalInformation program={program} />
      </GridItem>
      <SectionAccordion title={'Documentos agregados dentro del flujo'}>
        <GridItem>
          <RenderFlowDocuments program={program} />
        </GridItem>
      </SectionAccordion>
    </Grid>
  )
}

export default NewbornBenefit
